import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { boardblendApi } from "@/store/api";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(boardblendApi.middleware),
  reducer: {
    [boardblendApi.reducerPath]: boardblendApi.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
